export enum CreateableSecretFolder {
    PrivilegeGenericPassword = "Privilege - Generic Password",
    ServiceGenericPassword = "Service - Generic Password",
    ServiceSqlAccount = "SQL"
}